<template>
  <div>
    <FAhero />
    <FAservices />
  </div>
</template>

<script>
import FAhero from "@/components/FAhero.vue";
import FAservices from "@/components/FAservices.vue";
export default {
  components: {
    FAhero,
    FAservices
  }
};
</script>

<style lang="scss" scoped></style>
